document.addEventListener("DOMContentLoaded", function () {
  const scrollTriggers = document.querySelectorAll("[data-scroll-to-simple-tabs]");
  const headerOffset = 100;

  scrollTriggers.forEach(trigger => {
    trigger.addEventListener("click", function (e) {
      if (window.innerWidth <= 767) {
        e.preventDefault();

        const targetAttr = trigger.getAttribute("data-attr");
        if (!targetAttr) return;
        let target = document.querySelector(`[data-scroll-target='${targetAttr}']`);
        if (!target) {
          const normalizedId = targetAttr.trim().toLowerCase().replace(/\s+/g, "-");
          target = document.querySelector("#" + normalizedId);
        }

        if (!target) {
          const sectionElements = document.querySelectorAll("section[id*='" + targetAttr + "']");
          if (sectionElements.length > 0) {
            target = sectionElements[0];
          }
        }

        if (target) {
          const sectionTarget = target.closest("section");
          const finalTarget = sectionTarget || target;
          
          const elementPosition = finalTarget.getBoundingClientRect().top + window.scrollY;
          const offsetPosition = elementPosition - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
          });
        }
      }
    });
  });
});

